<template>
  <div class="columns">
    <div class="column is-one-third">
      <div class="card">
        <div class="card-image">
          <figure class="image is-4by3">
            <a target="_blank" href="https://team.picasoft.net/labos-1point5">
              <img src="@/assets/images/mattermost.png" />
            </a>
          </figure>
        </div>

        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{ $t('compAdminLinks.title') }}</p>
              <p class="subtitle is-6">
                <small>
                  <a
                    class="link"
                    target="_blank"
                    href="https://team.picasoft.net/signup_user_complete/?id=6r7cx4f1ufbu3n7ie95fytod3y"
                  >
                    <span class="icon is-small">
                      <i class="fa fa-pencil" />
                    </span>
                    {{ $t('compAdminLinks.register') }}
                  </a>
                </small>
              </p>
            </div>
          </div>
          <div class="content">
            <span v-html="$t('compAdminLinks.text-1')" />
            <p v-html="$t('compAdminLinks.text-2')" />
            <ul style="list-style-type: none; margin-left: 25px">
              <li>
                <a
                  class="link"
                  target="_blank"
                  href="https://team.picasoft.net/labos-1point5/channels/ges-1point5"
                >
                  <span class="icon is-small">
                    <i class="fa fa-thermometer" />
                  </span>
                  GES 1point5
                </a>
              </li>

              <li>
                <a
                  class="link"
                  target="_blank"
                  href="https://team.picasoft.net/labos-1point5/channels/cscenario-1point5"
                >
                  <span class="icon is-small">
                    <i class="fa fa-crosshairs" />
                  </span>
                  Ekocentral Scenario
                </a>
              </li>

              <li>
                <a
                  class="link"
                  target="_blank"
                  href="https://team.picasoft.net/labos-1point5/channels/transition-1point5-public"
                >
                  <span class="icon is-small">
                    <i class="fa fa-lightbulb-o" />
                  </span>
                  Transition 1point5
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Links'
}
</script>
